export type EntityKind = '' | 'CSE' | 'Entreprise' | 'Association' | 'Collectivité' | 'Autre'

export type InvoiceMode = 'monthly' | 'per_order'

export interface DeliveryAddress {
  id: string
  siteName: string
  street: string
  city: string
  zipcode: string
  country: string
  prefilled?: boolean
}

export interface BillingAddress {
  number: string
  street: string
  city: string
  zipcode: string
  country: string
}

export interface EnrollmentForm {
  companyName: string
  entityKind: EntityKind
  entityKindOther: string
  siret: string
  siren: string
  vatNumber: string
  rcs: string
  nafCode: string
  employeeRange: string
  adminFullName: string
  contactRole: string
  contactRoleOther: string
  adminEmail: string
  mobilePhone: string
  landlinePhone: string
  password: string
  passwordConfirmation: string
  billingAddress: BillingAddress
  invoiceMode: InvoiceMode
  deliveryAddresses: DeliveryAddress[]
  acceptedCgu: boolean
  acceptedRgpd: boolean
  optinNewsletter: boolean
  wantsPhysicalCards: boolean
  wantsVirtualCards: boolean
  physicalDeliveryAddresses: DeliveryAddress[]
}

export interface PartnerPrefillData {
  companyName: string
  siret: string
  siren: string
  vatNumber: string
  adminFullName: string
  adminEmail: string
  billingAddress: BillingAddress
  deliveryAddresses: DeliveryAddress[]
}

export interface EnrollmentResult {
  carrefourProId: string
  passAvantageId: string
}

export function createEmptyAddress(): DeliveryAddress {
  return {
    id: `addr_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    siteName: '',
    street: '',
    city: '',
    zipcode: '',
    country: 'FR'
  }
}

export function createEmptyEnrollmentForm(): EnrollmentForm {
  return {
    companyName: '',
    entityKind: '',
    entityKindOther: '',
    siret: '',
    siren: '',
    vatNumber: '',
    rcs: '',
    nafCode: '',
    employeeRange: '',
    adminFullName: '',
    contactRole: '',
    contactRoleOther: '',
    adminEmail: '',
    mobilePhone: '',
    landlinePhone: '',
    password: '',
    passwordConfirmation: '',
    billingAddress: {
      number: '',
      street: '',
      city: '',
      zipcode: '',
      country: 'FR'
    },
    invoiceMode: 'per_order',
    deliveryAddresses: [],
    acceptedCgu: false,
    acceptedRgpd: false,
    optinNewsletter: false,
    wantsPhysicalCards: false,
    wantsVirtualCards: false,
    physicalDeliveryAddresses: []
  }
}

export function getDemoPartnerPrefill(): PartnerPrefillData {
  return {
    companyName: 'Groupe Dupont SARL',
    siret: '45281937500018',
    siren: '452 819 375',
    vatNumber: 'FR68452819375',
    adminFullName: 'Marie Dupont',
    adminEmail: 'm.dupont@groupedupont.fr',
    billingAddress: {
      number: '12',
      street: 'avenue des Champs-Élysées',
      city: 'Paris',
      zipcode: '75008',
      country: 'FR'
    },
    deliveryAddresses: [
      {
        id: 'prefill_1',
        siteName: 'Siège social — Paris',
        street: '12 avenue des Champs-Élysées',
        city: 'Paris',
        zipcode: '75008',
        country: 'FR',
        prefilled: true
      },
      {
        id: 'prefill_2',
        siteName: 'Site de Lyon — Part-Dieu',
        street: '45 rue de la République',
        city: 'Lyon',
        zipcode: '69002',
        country: 'FR',
        prefilled: true
      }
    ]
  }
}
